import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, watch } from 'vue'

import CodeInput from '../components/codeInput.vue'
import FormItem from '../components/formItem.vue'
import inputTableVue from '../components/inputTable.vue'
import { Knif } from '../util/types'
import {
  codeList,
  holeSetting,
  knivesColumns,
  slotSetting,
} from './customSecondConf'


export default /*#__PURE__*/_defineComponent({
  __name: 'customSecond',
  props: {
    data: null
  },
  emits: ['onDataChange'],
  setup(__props: any, { emit }) {

const props = __props as { data: any }





const formData = reactive<{ [key: string]: any }>({
  beginCode: '',
  pauseCode: '',
  endCode: '',
  leftTurnCode: '',
  leftTurnEndCode: '',
  backTurnCode: '',
  backTurnEndCode: '',
  rightTurnCode: '',
  rightTurnEndCode: '',
  frontTurnCode: '',
  frontTurnEndCode: '',
  holeMove: '',
  punchHole: '',
  swingCode: '',
  holeStop: '',
  freeSlot: '',
  punchSlot: '',
  cutFace: '',
  stopCode: '',
  knives: {},
})

const tableData = ref<Knif[]>([])

// 传入表单数据处理
watch(
  () => props.data,
  (val) => {
    if (val) {
      for (const key in formData) {
        formData[key] = val.settingV2[key]
      }
      tableData.value = []
      for (const key in val.knives) {
        tableData.value.push(Knif.fromFirstSetting(val.knives[key]))
      }
    }
  },
  {
    immediate: true,
  }
)

//表格数据变动
watch(
  () => tableData.value,
  (val) => {
    if (val) {
      let knives: { [key: string]: any } = {}
      val.forEach((knif) => {
        knives[knif.id] = knif
      })
      formData.knives = knives
    }
  },
  {
    deep: true,
  }
)

// 表单数据传出
watch(
  () => formData,
  (val) => {
    emit('onDataChange', val)
  },
  {
    deep: true,
  }
)

return { __sfc: true,props, emit, formData, tableData, CodeInput, FormItem, inputTableVue, codeList, holeSetting, knivesColumns, slotSetting }
}

})